define([
    'edge/platform/base/BaseCtrl',
    'underscore',
    'edge/platform/util/LocalDateUtil',
], (BaseCtrl, _, LocalDateUtil) =>{

    const fn = (InsuranceSuiteMetadata, $scope, ViewModelService, MFPService, BASLER_QUESTIONSET_CONFIG, TCS_PRODUCT_CODE, DTO_CLASSES, submissionViewModel, StateUtils, BaslerCommonService, $timeout, AddressLookupService, $q, ContextService, LoggingService, BaslerLoggingConstants) => {

        const ctrl = Object.create(BaseCtrl);

        ctrl.init = function () {

            const submission = submissionViewModel().value;
            // We have to retrieve "Quoted" status, to set the initial context to BaslerContactDTO
            // This is because the requiredness of some fields (like first name, last name, etc...) depends on
            // The status of the quote: in other works, we only require first name after quote.
            // This is controlled by a context variable called "policyStatus"
            const viewModelContext = {policyStatus: BaslerCommonService.getTypecode('PolicyPeriodStatus', 'Quoted').priority};
            submission.draftData.dataProcessingConfirmed = ContextService.getDataProcessingConfirmed();

            $scope.$watch('quoteandbind.submissionView.draftData.dataProcessingConfirmed.value', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    ContextService.setDataProcessingConfirmed(newValue);
                }
            });

            $scope.quoteandbind = {
                submission: submission,
                submissionView: ViewModelService.create(submission, 'pc', DTO_CLASSES.QUOTE_DATA_DTO, viewModelContext),
            };

            initQuestionSets();
            $scope.accountHolderAsView = $scope.quoteandbind.submissionView.draftData.accountHolder.contact;
            $scope.additionalDriverAsView = isAccountHolderMainDriversOrIsVariousDriver($scope.quoteandbind.submission.draftData)
                ? null
                : $scope.quoteandbind.submissionView.draftData.lobs.mFPLine.drivers.children[0].person;
            $scope.captureTcsNumber = $scope.quoteandbind.submission.draftData.productCode === TCS_PRODUCT_CODE;

            const quoting = $scope.quoteandbind.submission.quoteData;
            $scope.selectedQuote = _.findWhere(quoting.offeredQuotes, {isSelected: true});

            // Reset registrationDate for leasing
            if (ContextService.isPartnerLeasingProduct()) {
                $scope.quoteandbind.submission.draftData.lobs.mFPLine.vehicles.forEach((vehicle) => {
                    vehicle.registrationDate = LocalDateUtil.toLocalDate(new Date());
                });
            }
        };

        function initQuestionSets() {
            $scope.questionSets = $scope.quoteandbind.submission.draftData.lobs.mFPLine.preQualQuestionSets;
            $scope.questionSetsConfig = BASLER_QUESTIONSET_CONFIG.createPostQuoteConfig($scope.quoteandbind.submission);
        }

        function scrollToFirstError() {
            //Scroll to first field with error
            const scroll = function () {
                if ($('.gw-error-inline').length > 0) {
                    $('html, body').animate({ scrollTop: $('.gw-error-inline').offset().top - 60 }, 1000);
                }
            };
            $timeout(scroll);
        }

        function isAccountHolderMainDriversOrIsVariousDriver(draftData) {
            return MFPService.accountHolderIsMainDriver(draftData) || (MFPService.hasVariousDrivers(draftData))
        }

        // Save the submission, quote it and forward to the quoting page
        ctrl.setNextState = function (form) {
            form.submitted = true;

            if (!form.valid) {
                scrollToFirstError();
                return;
            }

            //for the rare cases - double check street validity if it didn't finish before "Next" click
            let driverAddressLookupResult;
            if (isAccountHolderMainDriversOrIsVariousDriver($scope.quoteandbind.submission.draftData)) {
                driverAddressLookupResult = true;
            } else {
                const driverAddress = $scope.quoteandbind.submission.draftData.lobs.mFPLine.drivers[0].person.primaryAddress;
                AddressLookupService.validateStreet('textToStreetValidation2', driverAddress.postalCode, driverAddress.city, driverAddress.addressLine1);
            }

            //for the rare cases - double check street validity if it didn't finish before "Next" click
            let primaryAddressLookupResult;
            const isSearchedCompany = $scope.quoteandbind.submission.draftData.accountHolder.contact.isCompany && angular.isDefined($scope.quoteandbind.submission.draftData.accountHolder.contact.crefoId);
            if (isSearchedCompany) {
                primaryAddressLookupResult = true;
            } else {
                const primaryAddress = $scope.quoteandbind.submission.draftData.accountHolder.contact.primaryAddress;
                primaryAddressLookupResult = AddressLookupService.validateStreet('textToStreetValidation', primaryAddress.postalCode, primaryAddress.city, primaryAddress.addressLine1);
            }

            // If street(s) is/are invalid, stay on current page
            if (primaryAddressLookupResult === false || driverAddressLookupResult === false) {
                scrollToFirstError();
                return;   
            }
            
            // If street(s) is/are valid, move to next page
            if (primaryAddressLookupResult === true && driverAddressLookupResult === true) {
                ContextService.setDataProcessingConfirmed($scope.quoteandbind.submission.draftData.dataProcessingConfirmed);
                LoggingService.logInfo(BaslerLoggingConstants.CHANGEPAGE);
                return StateUtils.activeDataForState(true).flowModel.next($scope.quoteandbind.submissionView);
            }

            // If street(s) is/are to be checked to the backend, wait for response(s)...
            return $q.all([primaryAddressLookupResult, driverAddressLookupResult])
                .then((responses) => {
                    if (!_.contains(responses, false)) {
                        ContextService.setDataProcessingConfirmed($scope.quoteandbind.submission.draftData.dataProcessingConfirmed);
                        return StateUtils.activeDataForState(true).flowModel.next($scope.quoteandbind.submissionView);
                    }

                    scrollToFirstError();
                });

        };


        /*
         * Function to display UWIssues that shall not redirect to contact us page.
         * Watch changes in submissionViewModel(), that it's modified by Flow API
         */
        $scope.$watch(submissionViewModel, () => MFPService.showUWPopupIfNeeded(submissionViewModel()));

        ctrl.goToPrevious = function () {
            StateUtils.activeDataForState(true).flowModel.previous($scope.quoteandbind.submissionView);
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['InsuranceSuiteMetadata', '$scope', 'ViewModelService', 'MFPService', 'BASLER_QUESTIONSET_CONFIG', 'TCS_PRODUCT_CODE', 'DTO_CLASSES', 'submissionViewModel', 'StateUtils', 'BaslerCommonService', '$timeout', 'AddressLookupService', '$q', 'ContextService', 'LoggingService', 'BaslerLoggingConstants'];

    return fn;

});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/controllers/MFPPersonificationQualificationCtrl.js